<template>
  <div id="footer" class="container-fluid1">
    <div class="information-box">
      <div class="footer-left-box">
        <div class="item-box">
          <div class="name">官方公众号</div>
          <img
            v-lazy="require('@/assets/img/footer/code2.jpg')"
            alt="官方公众号"
          />
        </div>
        <div class="item-box">
          <div class="name">官方视频号</div>
          <img
            v-lazy="require('@/assets/img/footer/code1.jpg')"
            alt="官方视频号"
          />
        </div>
        <div class="item-box">
          <div class="name">官方微博</div>
          <img
            v-lazy="require('@/assets/img/footer/code3.jpg')"
            alt="官方微博"
          />
        </div>
        <div class="item-box">
          <div class="name">官方抖音</div>
          <img
            v-lazy="require('@/assets/img/footer/code4.png')"
            alt="官方抖音"
          />
        </div>
      </div>
      <div class="footer-right-box">
        <div class="item-box">
          <div class="name">
            <span>产品咨询</span>
          </div>
          <div class="txt">400-168-0262</div>
        </div>
        <div class="item-box">
          <div class="name">
            <span>商务合作</span>
          </div>
          <div class="txt">020-82286996</div>
        </div>
        <div class="item-box">
          <div class="name">
            <span>邮箱</span>
          </div>
          <div class="txt">Marketing@cyberway.net.cn</div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="center">
        <div class="left-box">
          <img v-lazy="require('@/assets/img/logo/logo-w.png')" alt="赛博威" />
          <span>©2002-2025 广东赛博威信息科技有限公司版权所有，侵权必究！</span>
        </div>
        <!--cyberway.com.cn 开始 -->
        <div class="right-box">
          <div class="txt txt1" @click="jumpTo('https://beian.miit.gov.cn')">粤ICP备17158128号-12</div>
          <div class="txt" @click="jumpTo('https://beian.mps.gov.cn/#/query/webSearch?code=44011202002759')">
            <img v-lazy="require('@/assets/img/footer/icon.png')" />粤公网安备44011202002759号

          </div>
        </div>
        <!--cyberway.com.cn 结束 -->
        <!--cyberway.net.cn 开始 -->
        <!-- <div class="right-box">
          <a href="https://beian.miit.gov.cn" target="_blank">
            <div class="txt txt1" @click="jumpTo('https://beian.miit.gov.cn')">粤ICP备17158128号</div>
          </a>
          <div class="txt" @click="jumpTo('https://beian.mps.gov.cn/#/query/webSearch?code=44011202001029')">
            <img v-lazy="require('@/assets/img/footer/icon.png')" />粤公网安备案
            44011202001029号
          </div>
        </div> -->
        <!--cyberway.net.cn 结束 -->
      </div>
    </div>
    <!-- <div class="friend-link">友情链接：上海斯歌</div> -->
    <!-- <div class="logo">
      <img v-lazy="require('@/assets/img/logo_white.png')" alt="logo图">
    </div> -->
    <!-- <p class="title">公司企业网站模板</p>
    <p class="address_tel_fax">
      <span>地址：公司地址</span>
      <span>Tel：888-888-888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：xxx@163.com</span>
      <span>微信号：xxx</span>
    </p>
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 公司名称</p> -->
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    jumpTo(url) {
      window.open(url);
    }
  }
};
</script>
<style scoped lang="scss">
#footer {
  width: 100%;
  height: 534px;
  color: #fff;
  background: #202329;
  overflow: hidden;
  text-align: center;
  animation: wait-in 3s ease;
}
.container-fluid1 {
  position: relative;
  .information-box {
    width: 1600px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 50px;
    .footer-left-box {
      width: 584px;
      height: 295px;
      display: flex;
      align-items: center;
      // justify-content: space-around;
      // box-shadow: 0 0 10px rgba(128, 128, 128, 0.08);
      .item-box {
        width: 100px;
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-left: 68px;
        .name {
          display: inline-block;
          font-size: 18px;
          color: #ffffff;
          font-family: "MiSans-Bold-";
          line-height: 80px;
          margin: 0 auto;
          background-image: linear-gradient(to bottom, #2881ff, #2881ff);
          background-position: 0 100%;
          background-repeat: no-repeat;
          background-size: 100% 2px;
          text-decoration: none;
          margin-bottom: 30px;
        }
        img {
          width: 100px;
          height: 100px;
          background-color: #ffffff;
        }
      }
    }
    .footer-right-box {
      display: flex;
      // align-items: center;
      justify-content: space-around;
      margin-left: auto;
      .item-box {
        margin-right: 102px;
        text-align: left;
        display: flex;
        flex-direction: column;

        &:nth-child(3) {
          margin-right: 20px;
        }
        .name {
          display: inline-block;
          font-size: 18px;
          color: #ffffff;
          font-family: "MiSans-Bold-";
          line-height: 80px;
          background-position: 0 100%;
          background-repeat: no-repeat;
          background-size: 100% 2px;
          text-decoration: none;
          margin-bottom: 30px;

          span {
            display: inline-block;
            background-image: linear-gradient(to bottom, #2881ff, #2881ff);
            background-position: 0 100%;
            background-repeat: no-repeat;
            background-size: 100% 2px;
          }
        }
        .txt {
          font-size: 18px;
          color: #bcbcbc;
          font-family: "MiSans-Regular-";
        }
      }
    }
  }
  .bottom-box {
    width: 100%;
    height: 106px;
    padding: 0 165px 0 183px;
    box-sizing: border-box;
    background-color: #191c21;
    position: absolute;
    bottom: 0;
    left: 0;
    .center {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .left-box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: auto;
        height: 38px;
        margin-top: -10px;
        margin-right: 30px;
      }
      span {
        font-size: 18px;
        color: #bcbcbc;
        font-family: "MiSans-Regular-";
      }
    }
    .right-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: auto;

      a {
        // 禁用下划线
        text-decoration: none;
      }
      .txt {
        font-size: 18px;
        color: #bcbcbc;
        font-family: "MiSans-Regular-";
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
            color: #fff;
          }
        img {
          width: 16px;
          height: 18px;
          margin-right: 4px;
        }
      }
      .txt1 {
        margin-right: 95px;
      }
    }
  }
  .friend-link {
    width: 100%;
    background-color: #00094c;
    position: absolute;
    bottom: 0;
    font-size: 15px;
    font-family: "MiSans-Demibold-";
    color: #ffffff;
    line-height: 31px;
  }
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}

/* 定义动画 */
@keyframes wait-in {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue